import React, { FormEvent, useCallback, useMemo, useState } from 'react'
import { BiLink } from 'react-icons/bi'
import { BsFillTrashFill, BsThreeDotsVertical } from 'react-icons/bs'
import { FiEdit3 } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import useApi from '../../hooks/useApi'
import { TextInput } from '../../Korbantech/components/Inputs/TextInput'
import Modal from '../../Korbantech/components/Modal'
import { Diagnosis } from '../../types/Diagnosis'
import { ContextMenu } from '../ContextMenu'

export const DiagnosisCard = ({ diagnosis }: Props) => {

    const api = useApi()
    const navigate = useNavigate()
    const [contextIsOpen, setContextIsOpen] = useState<boolean>(false)
    const [modalOPen, setModalOpen] = useState<boolean>(false)
    const countQuestion = useMemo(() => {
        if (diagnosis.questions_count === 1) return '1 questão'
        if (diagnosis.questions_count < 10) return '0' + diagnosis.questions_count + " questões"
        return diagnosis.questions_count + " questões"
    }, [diagnosis])

    const handleDelete = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const data = new FormData( e.currentTarget )
        if(diagnosis.name !== data.get("confirm_name") ){
            setModalOpen(false)
            return alert("Nome incorreto")
        }
        await api.delete(`/admin/diagnoses/${diagnosis.id}`).then(res => {
            window.location.reload()
        }).catch(console.log)
    }, [api, diagnosis])


    return (
        <div className='bg-white rounded border p-3'>
            <div className='flex justify-between relative'>
                <div className='text-lg font-semibold'>{diagnosis.name}</div>
                <div >
                    <BsThreeDotsVertical className='text-lg' onClick={() => setContextIsOpen(true)} />
                    <div className='relative'>
                    <ContextMenu open={contextIsOpen} close={() => setContextIsOpen(false)}>
                        <div className='flex items-center cursor-pointer' onClick={() => navigate(`/admin/testes/${diagnosis.id}`)}>
                            <FiEdit3 className='mr-1' />Editar
                        </div>
                        <div className='flex items-center cursor-pointer' onClick={() => setModalOpen(true)}>
                            <BsFillTrashFill className='mr-1 text-red-500' />Deletar</div>
                    </ContextMenu>
                    </div>
                </div>
            </div>
            <div className='font-normal text-gray-700 my-1'>{countQuestion}</div>
            <div className='text-gray-700'>Editado em {diagnosis.updated_at}</div>
            <button className='px-11 py-1 border rounded-md my-1 flex items-center'>
                <BiLink />  Copiar link
            </button>
            <Modal open={modalOPen} onClickCloseButton={() => setModalOpen(false)}>
                <form onSubmit={handleDelete} className="flex flex-col">
                    Digite o nome do teste para deletar
                    <TextInput required className="bg-gray-100 rounded-md" name="confirm_name" />
                    <button className='bg-red-500 rounded py-1 px-2 mt-2 self-end text-white'>Deletar</button>
                </form>
            </Modal>
        </div>
    )
}

interface Props {
    diagnosis: Diagnosis
}
